import type { SchemaBuilderFormProviderProps } from "./schema-builder-form.type";

import { SchemaBuilderFormContext } from "./schema-builder-form.context";

export const SchemaBuilderFormProvider = ({
  schema,
  context,
  children,
}: SchemaBuilderFormProviderProps) => {
  return (
    <SchemaBuilderFormContext.Provider value={{ schema, context }}>
      {children}
    </SchemaBuilderFormContext.Provider>
  );
};
